import {useCallback, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

const mapSelectValues = (item) => {return {value: item.id, label: item.name}};

let cache = null;

export default function useEventFilter() {
    const { t } = useTranslation();
    const [eventFilter, setEventFilter] = useState({
        cities: [{value: 0, label: t('conferences.filters.all')}],
        types: [{value: 0, label: t('conferences.filters.all')}],
        certificates: [{value: 0, label: t('conferences.filters.all')}],
        //specialties: [{value: 0, label: t('conferences.filters.all')}],
        organizers: [{value: 0, label: t('conferences.filters.all')}],
        prices: [
            {
                value: 0,
                label: t('conferences.filters.all'),
            },
            {
                value: 1,
                label: t('conferences.filters.price.free'),
            },
            {
                value: 2,
                label: t('conferences.filters.price.paid'),
            },
        ]
    });

    const fetchData = useCallback(() => {
        fetch('/api/v1/spa/conference-filter')
            .then(res => res.json())
            .then(
                (result) => {
                    const filter = {
                        ...eventFilter,
                        cities: eventFilter.cities.concat(result.cities
                            .filter((item) => item !== '')
                            .map((item) => {
                                return {value: item, label: item}
                            })),
                        types: eventFilter.types.concat(result.types.map(mapSelectValues)),
                        certificates: eventFilter.certificates.concat(result.certificates.map(mapSelectValues)),
                        //specialties: eventFilter.specialties.concat(result.specialties.map(mapSelectValues)),
                        organizers: eventFilter.organizers.concat(result.organizers.map(mapSelectValues)),
                    };

                    cache = filter;
                    setEventFilter(filter);
                }
            )
    }, [])

    useEffect(() => {
        if (cache) {
            setEventFilter(cache);
        } else {
            fetchData();
        }
    }, []);

    return eventFilter;
}
